import { useQuery } from '@tanstack/react-query'

import {
  getNoticeCategory,
  getNoticeDetail,
  getNoticeEventList,
  getNoticeList,
} from '~/features/notice/apis/notice'
import { type Filters } from '~/features/notice/types/notice'

const NOTICE_KEYS = {
  base: [{ scope: 'notice' }] as const,
  eventList: () => [{ ...NOTICE_KEYS.base[0], entity: 'eventList' }] as const,
  category: () => [{ ...NOTICE_KEYS.base[0], entity: 'category' }] as const,
  list: (filters: Filters) =>
    [{ ...NOTICE_KEYS.base[0], entity: 'list', filters }] as const,
  detail: (id: string) =>
    [{ ...NOTICE_KEYS.base[0], entity: 'detail', id }] as const,
}

export const useNoticeEventList = () => {
  return useQuery({
    queryKey: NOTICE_KEYS.eventList(),
    queryFn: () => getNoticeEventList(),
  })
}

export const useNoticeCategory = () => {
  return useQuery({
    queryKey: NOTICE_KEYS.category(),
    queryFn: () => getNoticeCategory(),
  })
}

export const useNoticeList = (filters: Filters) => {
  return useQuery({
    queryKey: NOTICE_KEYS.list(filters),
    queryFn: () => getNoticeList(filters),
  })
}

export const useNoticeDetail = (id: string) => {
  return useQuery({
    queryKey: NOTICE_KEYS.detail(id),
    queryFn: () => getNoticeDetail(id),
  })
}
